export enum ProveedorEstado {
  Borrador,
  Verificado,
  Rechazado,
  ConReserva,
}

export const ProveedorEstadoLabels: { [key in ProveedorEstado]: string } = {
  [ProveedorEstado.Borrador]: 'Borrador',
  [ProveedorEstado.Verificado]: 'Verificado',
  [ProveedorEstado.Rechazado]: 'Rechazado',
  [ProveedorEstado.ConReserva]: 'ConReserva',
};

export const getProveedorEstado = () => {
  return Object.values(ProveedorEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: ProveedorEstadoLabels[id as ProveedorEstado],
    }));
};

export const colorMapping: { [key in ProveedorEstado]: string } = {
  [ProveedorEstado.Borrador]: '#70BDFF',
  [ProveedorEstado.Verificado]: '#22c55e',
  [ProveedorEstado.Rechazado]: '#FF0000',
  [ProveedorEstado.ConReserva]: 'orange',
};
